import React, {useRef} from "react"

import ProjectSession from "../../../model2/project/project-session"
import {PopoverMenuItemType} from "../../../gd-components/popover-menu/popover-menu/const"
import PopoverMenuSeparator from "../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import PopoverMenuHeader from "../../../gd-components/popover-menu/popover-menu/popover-menu-header"
import PopoverMenuOption from "../../../gd-components/popover-menu/popover-menu/menu-option"
import PopoverMenuOptionWithCustomPopover
    from "../../../gd-components/popover-menu/popover-menu/option-with-custom-popover/menu-option-with-custom-popover"
import ProjectStatusManager from "../../../gd/manager/project-status-manager"
import delete_project from "./actions/delete-project"
import PopoverMenuOptionWithSubmenu
    from "../../../gd-components/popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu"
import MoreProject_PopoverMenuTop from "./compontent/top"
import archive_project from "./actions/archive-project"
import unarchive_project from "./actions/unarchive-project";
import moreProject_SelectIcon from "./compontent/icon";
import moreProject_SelectColor from "./compontent/color";
import MoreProject_MovePopover from "./compontent/move-popover"
import {BUS_PROJECT_SYSTEM_TYPE_CHANGED} from "../../../gd/bus/bus-event-type"

export enum MoreProject_PopoverMenuOption {
    INFO                = 'info',
    USERS               = 'users',
    SETTINGS            = 'settings',
    STATUS              = 'status',
    HISTORY             = 'history',

    EDIT_SOURCE         = 'edit-source',
    RENAME              = 'rename',
    COLOR_ICON          = 'color-icon',

    MOVE                = 'move',
    CONVERT             = 'convert',
    DUPLICATE           = 'duplicate',
    SAVE_AS_TEMPLATE    = 'save-as-template',
    DELETE              = 'delete',
}

type Props = {
    parent?         : any
    project         : ProjectSession
    hiddenOptions?  : MoreProject_PopoverMenuOption[]
    hidePopover     : callback
}

// const debug = "MoreProject_PopoverMenu"
const debug = false

export default function MoreProject_PopoverMenu(props:Props) {

    const selfRef: any = useRef()

    const options : any[] = []

    const onHistory = () => {
        gd.layout.popovers.closeAll()
        gd.navigation.goToHistory(props.project.rid)
    }

    const onUpdateStatus = () => {
        gd.layout.popovers.closeAll()
        gd.modals.project.updateStatus(props.project.id)
    }

    const getProjectStatusColorClass = () => {
        let status

        // types that run on the default system statuses rather than custom project ones -
        // anything missing here falls to the statusId lookup below
        if (props.project.isTag ||
            props.project.isFolder ||
            props.project.isPage ||
            props.project.isWhiteboard ||
            props.project.isCategory ||
            props.project.isSection ||
            props.project.isLink ||
            props.project.isEmbed ||
            props.project.isView ||
            props.project.isSupportSystem) {
            const statuses = ProjectStatusManager.exportDefaultStatusesToOptions(props.project.systemType)
            status = _.find(statuses, s=>s.value === props.project.systemStatus)
        } else {
            status = gd.session.statuses.get(props.project.statusId)
        }

        return status ? 'status-color-'+status.color : ''
    }

    const sessionProject    = gd.session.projects.get(props.project.id)
    const hasStandardAccess = props.project.acl.hasStandardAccess
    const hasFullAccess     = props.project.acl.hasFullAccess

    const availableMenuOptions  = props.project.properties.availableMenuOptions

    const showInfo              = availableMenuOptions.info && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.INFO)
    const showUsers             = availableMenuOptions.users && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.USERS)
    const showSettings          = availableMenuOptions.settings && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.SETTINGS)
    const showStatus            = availableMenuOptions.status && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.STATUS)
    const showHistory           = availableMenuOptions.history && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.HISTORY)
    const showEditSource        = availableMenuOptions.editSource && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.EDIT_SOURCE)
    const showRename            = availableMenuOptions.rename && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.RENAME)
    const showColorIcon         = availableMenuOptions.colorIcon && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.COLOR_ICON)

    const showMove              = availableMenuOptions.move && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.MOVE)
    const showConvert           = availableMenuOptions.convert && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.CONVERT)
    const showDuplicate         = availableMenuOptions.duplicate && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.DUPLICATE)
    const showSaveAsTemplate    = availableMenuOptions.saveAsTemplate && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.SAVE_AS_TEMPLATE)
    const showDelete            = availableMenuOptions.delete && !props.hiddenOptions?.includes(MoreProject_PopoverMenuOption.DELETE)

    if (showInfo) {
        options.push({
            label       : 'Info',
            icon        : 'ii5-information',
            disabled    : !hasStandardAccess,
            onClick     : ()=>{
                gd.layout.popovers.closeAll()
                gd.navigation.goToProject(props.project.id, '/info')
            }
        })
    }

    if (showUsers) {
        options.push({
            label       : 'Users',
            icon        : 'i5-users',
            disabled    : !hasStandardAccess,
            onClick     : ()=>{
                gd.layout.popovers.closeAll()
                gd.navigation.goToProject(props.project.id, '/info/users')
            }
        })
    }

    if (showSettings) {

        const settingsSections = props.project.properties.settingsSections

        options.push({
            type        : PopoverMenuItemType.SUBMENU,
            icon        : 'i5-settings',
            label       : 'Settings',
            disabled    : !hasFullAccess,
            options     : _.compact([
                settingsSections.workItems ?
                    {
                        label   : 'Work Items',
                        icon    : 'i5-task-types',
                        onClick : ()=>{
                            gd.layout.popovers.closeAll()
                            gd.navigation.goToProject(props.project.id, '/info/settings/work-items')
                        }
                    } : null,
                settingsSections.taskSettings ?
                    {
                        label   : 'Tasks',
                        icon    : 'i5-task',
                        onClick : ()=>{
                            gd.layout.popovers.closeAll()
                            gd.navigation.goToProject(props.project.id, '/info/settings/task-settings')
                        }
                    } : null,
                settingsSections.views ?
                    {
                        label   : 'Views',
                        icon    : 'i5-view',
                        onClick : ()=>{
                            gd.layout.popovers.closeAll()
                            gd.navigation.goToProject(props.project.id, '/info/settings/views')
                        }
                    } : null,
                settingsSections.navigation ?
                    {
                        label   : 'Navigation',
                        icon    : 'i5-portfolio',
                        onClick : ()=>{
                            gd.layout.popovers.closeAll()
                            gd.navigation.goToProject(props.project.id, '/info/settings/navigation')
                        }
                    } : null,
                settingsSections.emailTemplates ?
                    {
                        label   : 'Email Templates',
                        icon    : 'ii5-mail-black',
                        onClick : ()=>{
                            gd.layout.popovers.closeAll()
                            gd.navigation.goToProject(props.project.id, '/info/settings/email-templates')
                        }
                    } : null,
                settingsSections.workflow ?
                    {
                        label   : 'Workflow',
                        icon    : 'i5-statuses',
                        onClick : ()=>{
                            gd.layout.popovers.closeAll()
                            gd.navigation.goToProject(props.project.id, '/info/settings/workflow')
                        }
                    } : null,
            ])
        })
    }

    if (showStatus) {
        options.push({
            label       : "Update status",
            icon        : Classes("status", getProjectStatusColorClass()),
            onClick     : onUpdateStatus,
            disabled    : !hasFullAccess || sessionProject?.isTemplate,
            // show: actionsToShow.status
        })
    }

    if (showHistory) {
        options.push({
            icon        : "i5-recent",
            label       : "History",
            onClick     : onHistory,
            disabled    : !hasStandardAccess,
        })
    }

    // if any of the above options are added then add separator
    if (options.length > 0) {
        options.push({
            type        : PopoverMenuItemType.SEPARATOR
        })
    }

    /**--- Edit block [START] ---**/
    if (showEditSource) {
        options.push({
            label       : "Edit source",
            icon        : "i5-embeded-code",
            onClick     : async ()=>{
                props.project.editSource()
            },
            disabled    : !hasFullAccess,
        })
    }

    if (showRename) {
        options.push({
            label: "Rename",
            icon: "i5-pen",
            onClick: ()=>{
                if (props.parent?.onRename) {
                    props.parent.onRename()
                } else {
                    gd.modals.project.edit(sessionProject)
                }
            },
            disabled: !hasFullAccess,
        })
    }

    if (showColorIcon) {
        moreProject_SelectColor(props.project, options, !hasFullAccess)
    }

    // Change Icon
    if (showColorIcon) {
        moreProject_SelectIcon(props.project, options, !hasFullAccess)
    }

    const showSeparator = showMove || showConvert || showDuplicate || showSaveAsTemplate || availableMenuOptions.archive || showDelete
    showSeparator && options.push({
        type        : PopoverMenuItemType.SEPARATOR
    })
    /**--- Edit block [END] ---**/

    /*if (showMove) {
        options.push({
            label: "Move",
            icon: "i5-move",

            onClick: ()=>{
                gd.modals.project.move(null,props.project.id, ()=>{
                    // if (this.props.onMove) this.props.onMove();
                });
            },
            disabled: !hasFullAccess || sessionProject?.isTemplate,
        })
    }*/

    if (showMove) {
        options.push({
            type                : PopoverMenuItemType.CUSTOM_POPOVER,
            label               : "Move",
            icon                : "i5-move",
            menuComponent       : MoreProject_MovePopover,
            disabled            : !hasFullAccess || sessionProject?.isTemplate,
        })
    }

    if (showConvert) {
        options.push({
            label: "Convert",
            icon: "i5-type",
            onClick: ()=>{
                gd.modals.project.convert(null, props.project.id, () => {
                    gd.bus.triggerEvent(BUS_PROJECT_SYSTEM_TYPE_CHANGED, props.project.id)
                    // if (this.props.curMenuId === 'summary') gd.bus.triggerEvent(BUS_PROJECT_SYSTEM_TYPE_CHANGED);
                });
            },
            disabled: !hasFullAccess,
        })
    }

    if (showDuplicate) {
        options.push({
            label: "Duplicate",
            icon: "i5-clone",

            onClick: ()=>{
                if (!gd.company.license.isPro) {
                    gd.modals.other.upgrade()
                } else {
                    gd.modals.project.duplicate(sessionProject);
                }
            },
            disabled    : !hasFullAccess,
            // showPro     : !gd.company.license.isPro,
        })
    }

    if (showSaveAsTemplate) {
        options.push({
            label       : "Save as template",
            icon        : "i5-layers",

            onClick     : ()=>{
                if (!gd.company.license.isPro) {
                    gd.modals.other.upgrade()
                    return
                }

                gd.modals.project.saveAsTemplate(sessionProject)
            },
            // disabledonClick: this.onDisabledManagerClick,
            disabled: !hasFullAccess || !gd.user.isManager(),
            // showPro: !isPremium,

        })
    }

    // ARchive
    {availableMenuOptions.archive && !sessionProject?.isArchived &&
        options.push({
            label: "Archive",
            icon: "i5-someday",
            onClick: () => {
                archive_project(props.project)
            },
            disabled: !sessionProject?.acl.canArchive
        })
    }

    // Unarchive
    {availableMenuOptions.archive && sessionProject?.isArchived &&
        options.push({
            label: "Unarchive",
            icon: "i5-someday",
            onClick: () => {
                unarchive_project(props.project)
            },
            disabled: !sessionProject?.acl.canUnArchive
        })
    }

    if (showDelete) {
        options.push({
            label: "Delete",
            icon: "i5-trash-alt",
            onClick: () => {
                delete_project(props.project.id)
            },
            disabled: !hasFullAccess
        })
    }

    const classes = Classes("ui5-popover-menu", {
        'min-w-275': !props.project.isWorkspace,
        'min-w-200': props.project.isWorkspace,
    })

    return (
        <div ref={selfRef} className={classes}>

            <MoreProject_PopoverMenuTop project={props.project} hidePopover={props.hidePopover} />

            {_.map(options, (option, key) => {
                switch (option.type) {
                    case PopoverMenuItemType.CUSTOM_POPOVER:
                        const menuParams = {
                            project: props.project,
                            hidePopover: props.hidePopover
                        }
                        return <PopoverMenuOptionWithCustomPopover key={key}
                                                                   option={option}
                                                                   disabled={option.disabled}
                                                                   menuParams={menuParams}/>

                    case PopoverMenuItemType.SEPARATOR  :
                        return <PopoverMenuSeparator key={key}/>
                    case PopoverMenuItemType.HEADER     :
                        return <PopoverMenuHeader key={key}
                                                  title={option.title || option.label}/>

                    case PopoverMenuItemType.SUBMENU:
                        return <PopoverMenuOptionWithSubmenu key={key}
                                                             option={option}/>

                    default:
                        return <PopoverMenuOption key={key}
                                                  option={option}
                                                  hidePopover={props.hidePopover}/>
                }
            })}
        </div>
    );
}
